import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Clock } from '@one-thd/sui-icons';
import { CountdownTimer } from '@thd-olt-component-react/countdown-timer';
import {
  customType,
  params,
  string as StringType,
  useDataModel
} from '@thd-nucleus/data-sources';
import {
  CardContent,
  CardMedia,
  CardTitle,
  Typography
} from '@one-thd/sui-atomic-components';
import { getEndDate, getEndDateWithTimezoneOffset } from './Helper';

const SpecialBuyMessaging = ({
  previewDate,
  specialBuyType,
}) => {
  const { channel } = useContext(ExperienceContext);
  const [mounted, setMounted] = useState(false);
  const isMobile = channel === 'mobile';
  const dealType = specialBuyType === 'sbotd' ? 'DAY' : specialBuyType.toUpperCase();
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('special-buy-messaging.ready'); }, []);
  const { data } = useDataModel('specialBuyMetadata', {
    ssr: !previewDate,
    variables: {
      dealType,
      previewDate
    },
    context: { withSSO: previewDate }
  });

  useEffect(() => {
    setMounted(true);
  }, []);

  const isSBOTD = specialBuyType === 'sbotd';
  const isPro = specialBuyType === 'pro';

  const imageUrl = isSBOTD
    ? 'https://www.homedepot.com/SpecialBuy/images/Logo-SBOTD.svg'
    : 'https://assets.thdstatic.com/images/v1/sbotw-badge.svg';
  const title = isPro ? 'Pro Special Buy of The Week' : 'Special Buy of the Day';
  const content = isSBOTD ? 'Today Only!' : 'Online Only!';
  const subContent = 'Free Delivery*';
  const specialBuyEndDate = isSBOTD ? getEndDateWithTimezoneOffset(data?.specialBuyMetadata?.endDate, isSBOTD)
    : getEndDate(data?.specialBuyMetadata?.endDate);
  const subheader = (
    <div className="sui-pt-2 sui-pb-2 sui-pl-1 sui-flex sui-gap-2">
      <Typography color="primary" weight="bold" variant="body-lg">{content}</Typography> {subContent}
    </div>
  );
  const CustomImage = () => {
    return (
      <img src={imageUrl} alt="Placeholder img" height="90" width="90" />
    );
  };

  return (
    <div className={!isMobile ? 'grid' : ''} data-component="SpecialBuyMessaging">
      <div className={`grid-cols-3 sui-pb-6 sui-pl-1 ${isMobile ? 'sui-pt-3' : 'sui-pt-10'}`}>
        <div className=" sui-flex sui-gap-1">
          <CardContent orientation="horizontal" disablePadding>
            <div className={`sui-pl-2 sui-pr-3 ${isMobile ? 'sui-pt-4' : 'sui-pt-1'}`}>
              <CardMedia component={CustomImage} alt="Placeholder image" />
            </div>
          </CardContent>
          <CardContent disablePadding disableGutters initialSize="full">
            <CardTitle
              header={<Typography variant={!isMobile ? 'h1' : 'h2'} weight="bold">{title}</Typography>}
              disableTypography="true"
              headerWeight="bold"
              headerVariant="h3"
              subheader={<div className="sui-pl-1 sui-text-lg sui-pt-1">{subheader}</div>}
            />
          </CardContent>
        </div>
      </div>
      <div className={`sui-ml-auto sui-pr-2 sui-pb-3 ${!isMobile ? 'sui-pt-10' : ''}`}>
        <div className="sui-pr-1" hidden={isMobile}>
          <div className="sui-flex">
            <div className="sui-align-baseline sui-h-6 sui-pt-1 sui-w-6">
              <Clock size="small" color="subtle" />
            </div>
            <div>
              <Typography variant="body-lg"> Savings End </Typography>
            </div>
          </div>
        </div>
        <div className="sui-pl-6">
          {mounted && (
            <CountdownTimer
              classes="countdown-timer__wrapper--modifier"
              timebombThreshold={Infinity}
              isPromotionTimer
              shouldShowTextBelow={!isMobile}
              endDate={specialBuyEndDate}
              shouldUseClockDisplay={isMobile}
              shouldIncludeSvg={isMobile}
            />
          )}
        </div>
      </div>
    </div>
  );
};

SpecialBuyMessaging.displayName = 'SpecialBuyMessaging';

SpecialBuyMessaging.propTypes = {
  previewDate: PropTypes.string,
  specialBuyType: PropTypes.oneOf(['sbotd', 'pro'])
};

SpecialBuyMessaging.defaultProps = {
  previewDate: null,
  specialBuyType: 'sbotd'
};

SpecialBuyMessaging.dataModel = {
  specialBuyMetadata: params({
    dealType: customType('DealType').enum(['DAY', 'DECOR', 'PRO', 'ALL'], 'DAY'),
    previewDate: StringType()
  }).shape({
    endDate: StringType()
  })
};

export { SpecialBuyMessaging };
